import { Routes } from '@angular/router';

import { loginGuard } from './core/auth/guards/login.guard';
import { mainRoutes } from './core/main-layout/main-layout.routes';
import { ErrorRoutes } from './core/components/404/error.routes';

export const routes: Routes = [
  ...mainRoutes,
  ...ErrorRoutes,
  {
    path: 'login',
    loadComponent: () => import('./core/auth/pages/login/login.component').then(m => m.LoginComponent),
    canActivate: [loginGuard],
  },
  { path: '**', redirectTo: 'miscellaneous/error' },
];
